import config from "./config";

var axios = config();

export default {
  getActiveRequests() {
    return axios.get("/api/summerpayrequests");
  },
  getByAsurite(asurite) {
    return axios.get("/api/summerpayrequests/employee/" + asurite);
  },
  getByWorkload(workloadId) {
    return axios.get("/api/summerpayrequests/workload/" + workloadId);
  },
  getById(id) {
    return axios.get("/api/summerpayrequests/" + id);
  },
  postspRequest(spRequest, files) {
    var formData = new FormData();
    formData.append(
      "data",
      JSON.stringify(spRequest).replace(/<(?:.|\n)*?>/gm, "")
    );

    _.forEach(files, function(file) {
    // for (var file in files) {          // this DOES NOT WORK!!!!!!! File is not saved
      // add each file to the form data
      formData.append("files[]", file);
    });

    return axios.post("/api/summerpayrequests", formData);
  },
  putspRequest(spRequest) {
    return axios.put("/api/summerpayrequests", spRequest);
  },
  postStatus(spRequest) {
    return axios.post("/api/summerpayrequests/status", spRequest)
  },
  postFiles(id, files) {
    return axios.post("/api/summerpayrequests/" + id + "/files", files);
  },

  //emails
  statusEmail(id) {
    // dev hostname: https://api-local.chs.asu.edu:44326/ (from .env.development)
    return axios.post("/api/summerpayrequests/statusEmail/" + id);
  },

  submittedEmail(id) {
    return axios.post("/api/summerpayrequests/submittedEmail/" + id);
  },
  // utils
  getStatusDefinitions() {
    return axios.get("/api/summerpayrequests/statuses");
  }
};
